// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tooltip[data-v-38e80c8c] {\n    display: block !important;\n    z-index: 10000;\n}\n", ""]);
// Exports
module.exports = exports;
